import BaseAPIRepository, { BaseAPIResponse } from 'api/base';
import { AxiosResponse } from 'axios';
import { BASE_URL } from 'const';
import { FERequestErrorsHandler } from 'utils';
import { GetDishByIdRequestV3 } from '.';
import { GetDishByIdResponseV3 } from '.';

const dishesRepositoryV3 = {
  getDishById: (
    { id, catalogId }: GetDishByIdRequestV3,
    signal?: AbortSignal,
  ) =>
    new Promise<GetDishByIdResponseV3.Response>(async (resolve, reject) => {
      try {
        let url = `${BASE_URL}/not-secure/api/v3/dishes/${id}?catalogId=${catalogId}`;
        let result: AxiosResponse<
          BaseAPIResponse<GetDishByIdResponseV3.Response>
        > = await BaseAPIRepository.get<
          BaseAPIResponse<GetDishByIdResponseV3.Response>
        >(url, { signal });
        resolve(result.data.result);
      } catch (error: any) {
        FERequestErrorsHandler(error, reject);
      }
    }),
};

export default dishesRepositoryV3;
